<template>
    <v-dialog v-model="$store.state.CircleK.InvSum" fullscreen>
        <v-card>
            <v-toolbar color="primary" dense>
                <v-spacer />
                <v-toolbar-title class="white--text">
                    Invoice Summary
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="$store.state.CircleK.InvSum = false"
                    ><v-icon>mdi-close</v-icon></v-btn
                >
            </v-toolbar>
            <v-container>
                <v-data-table
                    :headers="headersSummary"
                    :items="Summary"
                    :search="search"
                    dense
                    height="900px"
                    disable-items-per-page
                    disable-pagination
                    class="custom-table"
                    hide-default-footer
                    :fixed-header="true"
                >
                    <template v-slot:top>
                        <v-row>
                            <v-col cols="4">
                                <v-text-field
                                    label="Search"
                                    v-model="search"
                                    class="mb-5"
                                    dense
                                    hide-details
                                ></v-text-field>
                            </v-col>
                            <v-col>
                                <v-btn
                                    color="success"
                                    small
                                    @click="downloadExcel"
                                >
                                    Download
                                    <v-icon>mdi-microsoft-excel</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </template>
                    <template slot="body.append">
                        <tr>
                            <td class="text-left font-weight-bold">Totals</td>
                            <td></td>
                            <td
                                class="font-weight-bold text-left pr-12"
                                style="font-size:14px;"
                            >
                                {{
                                    sumColumn(
                                        Summary,
                                        'SumOfSumOfTotal'
                                    ).toLocaleString('en-US', {
                                        style: 'currency',
                                        currency: 'USD'
                                    })
                                }}
                            </td>
                            <td
                                class="font-weight-bold text-left pr-12"
                                style="font-size:14px;"
                            >
                                {{
                                    sumColumn(
                                        Summary,
                                        'SumOfSumOfNetAmount'
                                    ).toLocaleString('en-US', {
                                        style: 'currency',
                                        currency: 'USD'
                                    })
                                }}
                            </td>
                            <!-- <td class="font-weight-bold text-left pr-12" style="font-size:14px;">{{ sumColumn(Summary, 'SuncorAmount').toLocaleString('en-US', { style: 'currency', currency: 'USD' }) }}</td> -->
                            <td
                                class="font-weight-bold text-left pr-12"
                                style="font-size:14px;"
                            >
                                {{
                                    sumColumn(
                                        Summary,
                                        'SumOfDiff'
                                    ).toLocaleString('en-US', {
                                        style: 'currency',
                                        currency: 'USD'
                                    })
                                }}
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props: ['parms'],
    data: function() {
        return {
            headersSummary: [
                { text: 'InvId', value: 'InvId' },
                { text: 'InvDate', value: 'InvDate' },
                { text: 'UPTSumOfTotal', value: 'SumOfSumOfTotal' },
                { text: 'PmtsNetAmount', value: 'SumOfSumOfNetAmount' },
                { text: 'SumOfDiff', value: 'SumOfDiff' }
            ],
            Summary: [],
            Totals: {
                TotalNetAmount: null,
                TotalInvoiceNumber: null,
                TotalDiff: null
            },
            search: ''
        };
    },

    mounted() {
        console.log(this.parms);
        this.getMatchs();
    },
    methods: {
        sumColumn(items, key) {
            return items.reduce(
                (acc, item) => acc + parseFloat(item[key]) || 0,
                0
            );
        },
        getMatchs: function() {
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .post('conciliation/circle-k/invoice-summary-ck', this.parms)
                .then(async response => {
                    this.Summary = response.data;
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 405) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'This file is already uploaded.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        downloadExcel: function() {
            var str = this.$store;
            this.$store.state.isLoading = true;
            this.parms.Export = true;
            axios
                .post('conciliation/circle-k/invoice-summary-ck', this.parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;

                    link.setAttribute(
                        'download',
                        'Reconciliation Invoice Summary.xlsx'
                    );

                    document.body.appendChild(link);
                    link.click();

                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                    str.state.isLoading = false;
                });
        }
    }
};
</script>
